document.addEventListener("DOMContentLoaded", () => {

  // Fonction pour mettre à jour le délai de livraison
  const updateVariantSku = (selectedVariant) => {

    if (!selectedVariant)
      return;

    const variantSku = selectedVariant.dataset.variantSku;

    if (variantSku) {
      const skuElement = document.getElementById("layerdev-dynamic-sku");
      if (skuElement) {
        skuElement.textContent = variantSku;
      }
    }
  }

  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
    const selectedVariant = event.data.target;
    updateVariantSku(selectedVariant);
  });

});
